(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellowa-sales-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-comfort-catalog]').forEach((catalog) => {
      const buttons = [...catalog.querySelectorAll('[data-catalog-filter]')];
      const cards = [...catalog.querySelectorAll('[data-product-card]')];
      const emptyMessage = catalog.querySelector('[data-catalog-empty]');
      const resultsTitle = catalog.querySelector('[data-catalog-title]');
      const resultsCount = catalog.querySelector('[data-catalog-count]');
      const filterNames = {
        all: 'All products',
        care: 'Face & body care',
        pad: 'Heating pads',
        blanket: 'Heated blankets'
      };

      const applyFilter = (filter) => {
        let visibleCount = 0;
        cards.forEach((card) => {
          const show = filter === 'all' || card.dataset.productCategory === filter;
          card.hidden = !show;
          if (show) visibleCount += 1;
        });

        buttons.forEach((button) => {
          const active = button.dataset.catalogFilter === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        if (resultsTitle) resultsTitle.textContent = filterNames[filter] || 'Products';
        if (resultsCount) resultsCount.textContent = visibleCount;
        if (emptyMessage) emptyMessage.hidden = visibleCount !== 0;
      };

      buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.catalogFilter)));

      catalog.querySelectorAll('[data-jump-filter]').forEach((link) => {
        link.addEventListener('click', () => applyFilter(link.dataset.jumpFilter));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
